import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { MarkdownComponent, MarkdownModule, provideMarkdown } from 'ngx-markdown';

@Component({
  selector: 'app-validation-errors',
  standalone: true,
  imports: [MarkdownModule, MarkdownComponent],
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss'],
  providers: [provideMarkdown()],
})
export class ValidationErrorsComponent implements OnInit {
  markdownContent: string = '';
  isLoading: boolean = true;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadMarkdownFile();
  }

  loadMarkdownFile(): void {
    const markdownFilePath = 'assets/markdown/validation-guide.md';

    this.http.get(markdownFilePath, { responseType: 'text' }).subscribe({
      next: (content) => {
        this.markdownContent = content;
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load validation guide. Please try again later.';
        this.isLoading = false;
      },
    });
  }
}
